import { Button, Modal, Popconfirm, Space } from "antd";
import type { FC } from "react";
import type { DeploymentTarget } from "../../../types";

interface SeoTargetsModalProps {
  open: boolean;
  title: string;
  targets: DeploymentTarget[];
  onClose: () => void;
  onRemoveTarget: (environmentId: string) => void;
}

// Only "remove tracking" exists for SEO, unlike snippets' "remove tracking" vs "remove from
// site" choice: the WP plugin's SeoController has no DELETE route for settings/post-meta/
// redirects yet (see obsidian/Product/SEO Sync.md, "Pas de suppression distante"), so there's
// nothing to call remotely.
export const SeoTargetsModal: FC<SeoTargetsModalProps> = ({ open, title, targets, onClose, onRemoveTarget }) => {
  return (
    <Modal title={title} open={open} onCancel={onClose} footer={null}>
      <Space direction="vertical" style={{ width: "100%" }}>
        {targets.map((target) => (
          <Space key={target.id} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <span>{target.environmentName}</span>
            <Popconfirm
              title="Remove tracking"
              description="Loopress stops tracking this deployment. The data stays live on the target site; a future deploy here won't detect it as already up to date."
              onConfirm={() => onRemoveTarget(target.environmentId)}
              okText="Remove tracking"
              cancelText="Cancel"
            >
              <Button size="small">Remove tracking</Button>
            </Popconfirm>
          </Space>
        ))}
      </Space>
    </Modal>
  );
};
